import { type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { useTransitionOverlay } from '@/stores/transition-overlay';
import { Spinner } from './spinner';

export function TransitionOverlay(): ReactNode {
  const visible = useTransitionOverlay((s) => s.visible);
  if (!visible) return null;
  return createPortal(
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-void">
      <Spinner />
    </div>,
    document.body
  );
}
